'use client';
import * as React from 'react';
import { BackgroundImage } from './BackgroundImage';
import { useNavigate } from 'react-router-dom';
import {
	Card,
	CardContent,
	CardFooter,
	CardHeader,
	CardTitle,
	CardDescription,
} from './card';

export interface CategoryCardProps {
	backgroundImageUrl: string;
	title: string;
	description: string;
	ctaText: string;
	ctaIconUrl: string;
}

export const CategoryCard: React.FC<CategoryCardProps> = ({
	backgroundImageUrl,
	title,
	description,
	ctaText,
	ctaIconUrl,
}) => {
	const navigate = useNavigate();
	return (
		<Card className='flex flex-col overflow-hidden relative min-h-[560px] max-w-[427px] font-[Mona_Sans,-apple-system,Roboto,Helvetica,sans-serif] text-base text-[rgba(38,38,38,1)] rounded-lg shadow-lg border-0'>
			<BackgroundImage imageUrl={backgroundImageUrl} />

			<div className='absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl p-6 h-1/2'>
				<div className='h-full flex flex-col justify-between'>
					<div>
						<CardHeader className='p-0'>
							<CardTitle className='text-2xl font-bold mb-2'>{title}</CardTitle>
						</CardHeader>

						<CardContent className='p-0 py-3'>
							<CardDescription className='text-base text-gray-800'>
								{description}
							</CardDescription>
						</CardContent>
					</div>

					<CardFooter className='p-0'>
						<button
							className='flex items-center text-black font-semibold hover:text-[#fbb040]'
							onClick={() => navigate('/services')}
						>
							{ctaText}
							<div className='ml-2 bg-yaap-yellow rounded-full p-2 flex items-center justify-center'>
								<img src={ctaIconUrl} alt='' className='w-4 h-4' />
							</div>
						</button>
					</CardFooter>
				</div>
			</div>
		</Card>
	);
};

export default CategoryCard;
